import { SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { GoX } from "react-icons/go";

interface SearchHistoryDeleteButtonProps {
  showConfirmDialog: (message: string) => void;
  searchHistoryId: string;
  setSearchHistoryId: React.Dispatch<SetStateAction<string>>;
}

export const SearchHistoryDeleteButton: React.FC<
  SearchHistoryDeleteButtonProps
> = ({ showConfirmDialog, searchHistoryId, setSearchHistoryId }) => {
  //言語切替用
  const { t } = useTranslation();

  const handleOnDeleteButton = () => {
    showConfirmDialog(t("検索履歴画面.この検索履歴を削除しますか？")); //この検索履歴を削除しますか？
    setSearchHistoryId(searchHistoryId);
  };

  return (
    <div>
      <button
        onClick={handleOnDeleteButton}
        className="absolute right-0 overflow-visible p-1"
      >
        <GoX size={"1.25rem"} />
      </button>
    </div>
  );
};
